/*
 * @Author: Tango
 * @Date: 2020-12-24 14:23:28
 * @Last Modified by: yangfanliu
 * @Last Modified time: 2022-03-22 11:52:26
 */
<template>
  <div id="contribute">
    <content-title title="投稿作品信息"></content-title>
    <div class="content">
      <div class="contribute-form">
        <a-form :form="form" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-form-item class="cover-item" label="作品名称">
            <a-input
              v-decorator="[
                'package_title',
                {
                  rules: [
                    { required: true, message: '请填写作品名称' },
                    { max: 8, message: '最多输入8个字符' },
                  ],
                },
              ]"
              placeholder="请填写作品名称"
              :max-length="8"
              @change="nameChange"
            />

            <span style="color: #999999; margin-left: 20px"> 最多输入8个字符 </span>
          </a-form-item>

          <div v-if="contributeInfo.category != 3">
            <a-form-item label="批量上传" :required="true" class="cover-item" style="margin-bottom: 24px">
              <div class="cover-box">
                <multi-upload-image
                  :limit="1024"
                  :accept="['.jpeg,.jpg', '.png', '.jpeg,.jpg'][contributeInfo.category - 1]"
                  :path="elementPath"
                  :dataList="workList"
                  :category="`${contributeInfo.category}`"
                  :isWaterMark="true"
                >
                </multi-upload-image>
                <div
                  v-if="workList.length >= 30"
                  class="upload-max"
                  @click="() => this.$message.error('已经上传30张素材了，不可以上传新素材了哦')"
                ></div>
              </div>

              <div class="tips">
                <p style="margin: 0px 0 20px">一次可添加多个素材哦~~</p>
                <p>
                  尺寸：{{ [`高度小于等于1600像素`, `1000×1000像素以内`, `640*1138像素`][contributeInfo.category - 1] }}
                </p>
                <p>大小：小于1M</p>
                <p>格式：{{ [`JPG、JPEG`, `PNG`, `JPG、JPEG`][contributeInfo.category - 1] }}</p>
                <p>数量：每个素材包最多30张</p>
              </div>
            </a-form-item>
          </div>
          <div v-else>
            <a-form-item label="上传背景" :required="true" class="cover-item">
              <div class="cover-box">
                <upload-image
                  v-decorator="[
                    'package_image',
                    {
                      rules: [{ required: true, message: '请上传人设背景' }],
                      initialValue: human_card.package_image,
                    },
                  ]"
                  :limit="1024"
                  :bucketType="'5'"
                  @onSuccess="cardOnSuccess"
                  :addWaterImage="true"
                  :checkSize="checkElementSize"
                  :data="human_card"
                  :clip="true"
                  :clipOption="{
                    autoCropWidth: 640,
                    autoCropHeight: 1138,
                    fixedNumber: [640, 1138],
                    zoom: 0.4,
                    info: false,
                  }"
                  :path="materialPath"
                  :accept="'.jpeg,.jpg'"
                  :bgImg="require('@/assets/img/img_upload_120@2x.png')"
                  class="card-upload"
                >
                </upload-image>
              </div>

              <div class="tips">
                <p>尺寸：640*1138像素</p>
                <p>格式：JPG、JPEG</p>
                <p>大小：小于1M</p>
                <p>
                  <span class="psd-card-icon">
                    <img src="@/assets/img/icon_psd_18_20@2x.png" alt="" />
                  </span>
                  <a
                    class="download-psd"
                    :href="`${
                      constv.APP_ENV == 'prod'
                        ? '/download/card_demo.psd'
                        : 'http://web-all.mindcomic.com/demo/zpace/download/card_demo.psd'
                    }`"
                    download="人设卡模板.psd"
                    >PSD模板下载</a
                  >
                </p>
              </div>
            </a-form-item>
          </div>

          <div v-if="contributeInfo.category != '3'">
            <a-form-item class="cover-item" label="填写元素信息" :required="true" v-if="workList.length > 0">
              <!-- <a-button type="link" style="padding-left: 0">填如何填写元素信息？</a-button> -->
              <div class="file-list">
                <div
                  v-for="(item, index) in workList"
                  :key="index"
                  class="file-item"
                  :class="{ error: item.error.length > 0 }"
                >
                  <div class="image-view">
                    <upload-image
                      style="border-radius: '8px'"
                      class="image-view__upload"
                      @onSuccess="elementOnSuccess"
                      :limit="1024"
                      :data="item"
                      :addWaterImage="true"
                      :path="elementPath"
                      :checkSize="checkElementSize"
                      :accept="['.jpeg,.jpg', '.png', '.jpeg,.jpg'][contributeInfo.category - 1]"
                      :bgImg="require('@/assets/img/material_bg.jpg')"
                    >
                    </upload-image>
                  </div>
                  <div class="name">
                    <a-input
                      type="text"
                      name="name"
                      placeholder="请输入作品名称"
                      id="name"
                      :max-length="8"
                      v-model="item.title"
                      style="height: 32px; border-radius: 4px"
                      @change="elementTitleChange($event, item)"
                    ></a-input>
                  </div>
                  <div
                    class="close font_family icon-icon_close_spheric_24"
                    @click.stop="showDeleteConfirm(index)"
                  ></div>
                  <p class="error-tips" v-if="item.error">{{ item.error }}</p>
                </div>
              </div>
            </a-form-item>
            <a-col :offset="2" v-if="workList.length > 0"> </a-col>
          </div>
          <div v-else>
            <a-form-item class="cover-item" label="预览效果" style="margin-left: 71px; margin-bottom: 32px">
              <div class="card-preview-list">
                <div class="card-preview-item">
                  <div class="title">人设背景</div>
                  <div v-if="human_card.image" class="card-preview-img card_1">
                    <img style="z-index: 2" src="@/assets/img/img_card_top_2.png" alt="" srcset="" />
                    <img style="z-index: 1" :src="`${constv.QINIU_IMAGE_QNC_CDN_URL}${human_card.image}`" alt="" />
                  </div>
                  <div v-else>
                    <img src="@/assets/img/img_card_default.png" alt="" />
                  </div>
                </div>
                <div class="card-preview-item">
                  <div class="title">人设卡片</div>
                  <div v-if="human_card.image" class="card-preview-img card_2">
                    <img style="z-index: 1" src="@/assets/img/img_card_0.png" alt="" srcset="" />
                    <div class="card-display">
                      <img style="z-index: 2" :src="`${constv.QINIU_IMAGE_QNC_CDN_URL}${human_card.image}`" alt="" />
                    </div>
                    <img style="z-index: 3" src="@/assets/img/img_card_2.png" alt="" srcset="" />
                  </div>
                  <div v-else>
                    <img src="@/assets/img/img_card_preview_default.png" alt="" />
                  </div>
                </div>
              </div>
            </a-form-item>
          </div>

          <div class="concat">
            <div style="padding: 0 36px">
              <div class="line" v-if="contributeInfo.show_contact == 1"></div>
            </div>

            <a-form-item
              class="cover-item"
              label="联系方式"
              style="margin-bottom: 40px"
              v-if="contributeInfo.show_contact == 1"
            >
              <a-input
                v-decorator="[
                  'contact',
                  {
                    rules: [{ required: true, message: '请填写联系方式' }],
                    getValueFromEvent: (event) => {
                      return event.target.value.replace(/^(0+)|[^\d]+/g, '')
                    },
                  },
                ]"
                :max-length="11"
                type="tel"
                placeholder="请填写联系方式"
                @change="contactChange"
              />
              <span
                style="color: #999999; margin-left: 20px; width:444px; display:inline-block;line-height:18px;font-size:12px;ant-form-item-children"
              >
                如果您的作品被企划选定，企划方将通过短信通知您。企划全程不收取费用，并保证您的联系方式不会对第三方透露。
              </span>
            </a-form-item>
          </div>
          <a-col :offset="2">
            <div class="btn-list" style="margin-left: 20px">
              <a-button class="btn" type="primary" :loading="!canSubmit" @click="submit">确定</a-button>
              <a-button class="btn" type="default" style="margin-left: 20px" @click="goback">取消</a-button>
            </div>
          </a-col>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import contentTitle from '@/components/Zpace/common/contentTitle'
import { mapActions } from 'vuex'
import UploadImage from '@/components/Zpace/UploadImage/UploadImage'
import MultiUploadImage from '@/components/Zpace/UploadImage/MultiUploadImage'
import { getBase64, getRandom } from '@/utils/util.js'
import * as qiniu from 'qiniu-js'
export default {
  name: 'Planning',
  data () {
    return {
      materialPath: 'resources/cloud/title_image_web/',
      statusMap: {
        0: {
          text: '未开始',
          status: 'default'
        },
        1: {
          text: '进行中',
          status: 'processing'
        },
        2: {
          text: '评选中',
          status: 'success'
        },
        3: {
          text: '已结束',
          status: 'default'
        }
      },
      contributeInfo: {},
      formData: {
        package_title: '',
        category: '',
        contact: '',
        res_data: []
      },
      workList: [],
      human_card: {
        width: '',
        height: '',
        title: '',
        package_image: '',
        loading: false,
        percent: 0,
        image: ''
      },
      delIndex: '',
      form: this.$form.createForm(this),
      id: this.$route.params.id,
      canSubmit: true
    }
  },
  components: { contentTitle, UploadImage, MultiUploadImage },
  computed: {
    elementPath () {
      return 'resources/contributeInfo_web/'
    }
  },
  created () {
    this.getInfo()
  },
  mounted () { },
  methods: {
    ...mapActions(['getQiniuToken']),
    // 生成图片名字
    name () {
      return getRandom(4) + Math.floor(new Date().getTime() / 1000) + getRandom(4)
    },
    goDetail () {
      this.$router.push({
        path: '/manage/planDetail'
      })
    },
    nameChange (e) {
      this.formData.package_title = e.target.value
      if (this.contributeInfo.category == '3') {
        this.human_card.title = e.target.value
      }
    },
    contactChange (e) {
      this.formData.contact = e.target.value
    },
    // 批量上传
    // async onMultiUpload (file) {
    //   if (this.workList.length >= 30) {
    //     if (this.uploadTimer) {
    //       clearTimeout(this.uploadTimer)
    //     }
    //     this.uploadTimer = setTimeout(() => {
    //       this.uploadTimer = null
    //       this.$message.error('已经上传30张素材了，不可以上传新素材了哦')
    //     }, 500)
    //     return false
    //   }
    //   this.workList.push(
    //     Object.assign(
    //       {
    //         width: '',
    //         height: '',
    //         loading: false,
    //         percent: 0,
    //         title: '', // file.name.split('.')[0].substring(0, 8)
    //         error: '',
    //         errorType: '',
    //         image: '',
    //         watermark_image: ''
    //       },
    //       file
    //     )
    //   )

    //   const last = this.workList.length - 1
    //   const typeList = ['.jpeg,.jpg', '.png', '.jpeg,.jpg'][this.contributeInfo.category - 1]
    //   const isJpgOrPng = typeList.split(',').findIndex((item) => {
    //     return file.type.indexOf(item.replace(/\./g, '')) > -1
    //   })
    //   if (isJpgOrPng < 0) {
    //     this.workList[last].error = `素材格式有误，请重新上传: 格式`
    //     this.workList[last].errorType = '1'
    //     return
    //   }

    //   if (this.limit) {
    //     const isLimit = file.size / 1024 < this.limit
    //     if (!isLimit) {
    //       this.workList[last].error = `素材格式有误，请重新上传: 大小`
    //       this.workList[last].errorType = '2'
    //       return
    //     }
    //   }
    //   this.checkElementSize(this.workList[last].originFileObj, this.workList[last])
    //     .then(async (res) => {
    //       await this.postImage(this.workList[last], this.elementPath)
    //       await this.addWaterMark(this.workList[last], this.elementPath)
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    // 上传到七牛
    async postImage (file, path) {
      const sendData = {
        action: 'upload',
        bucketType: '1'
      }
      // 获取七牛上传token
      await this.getQiniuToken(sendData)

      const params = {
        token: this.$store.state.texture.token,
        key: `${path}${this.name()}.${file.type.split('/')[1]}`
      }
      file.loading = true
      // 上传到七牛 拿到图片地址
      const observable = qiniu.upload(file.originFileObj, params.key, params.token)
      observable.subscribe({
        next: (result) => {
          // 主要用来展示进度
          file.percent = Math.round(result.total.percent).toFixed(0)
          if (file.percent === 100) {
            file.loading = false
          }
          // this.$emit('onChange', this.file)
        },
        error: () => {
          this.$message.error('上传图片失败')
        },
        complete: async (response) => {
          file.image = response.key // 返回的路径
          file.loading = false
        }
      })
    },
    // 添加水印
    async addWaterMark (file, path) {
      // 生成水印名字
      const waterMarkKey = `${path}${this.name()}.${file.originFileObj.type.split('/')[1]}`
      // 上传水印图片
      const sendData = {
        action: 'upload',
        bucketType: '2'
      }
      await this.getQiniuToken(sendData)

      // 上传到七牛 拿到图片地址
      const observable = qiniu.upload(file.originFileObj, waterMarkKey, this.$store.state.texture.token)
      observable.subscribe({
        next: (result) => {
          // 主要用来展示进度
        },
        error: () => {
          this.$message.error('上传水印图片失败')
        },
        complete: (response) => {
          file.watermark_image = response.key // 返回的路径
        }
      })
    },
    elementTitleChange (e, item) {
      item.title = e.target.value
      if (e.target.value !== '' && item.errorType === '4') {
        item.error = ''
      }
    },
    // 上传前检测尺寸是否符合
    checkElementSize (file, scopeData) {
      return new Promise((resolve, reject) => {
        getBase64(file, (oImg) => {
          const img = new Image()
          img.src = oImg
          img.onload = () => {
            scopeData.width = img.width
            scopeData.height = img.height
            if (this.contributeInfo.category == '1') {
              // 如果是场景 height 小于1600
              if (img.height > 1600) {
                if (scopeData.image) {
                  this.$message.error('只能上传高度小于1600像素的图片')
                } else {
                  scopeData.error = '尺寸有误，请重新上传'
                  scopeData.errorType = '3'
                }
                const err = 'err'
                reject(err)
              } else {
                resolve('ok')
              }
            } else if (this.contributeInfo.category == '2') {
              // 如果是贴图  width < 640 && height < 800
              if (img.width > 1000 || img.height > 1000) {
                if (scopeData.image) {
                  this.$message.error('只能上传1000×1000像素以内的图片')
                } else {
                  scopeData.error = '尺寸有误，请重新上传'
                  scopeData.errorType = '3'
                }
                const err = 'err'
                reject(err)
              } else {
                resolve('ok')
              }
            }
          }
        })
      })
    },
    // 元素上传成功
    async elementOnSuccess (response, filename, file, data) {
      data.image = response.key
      let img = new Image()
      getBase64(file, (oimg) => {
        img.src = oimg
        img.onload = () => {
          data.width = img.width
          data.height = img.height
          img = null
        }
      })
      // 上传水印图片
      // data.originFileObj = file
      // await this.addWaterMark(data, this.elementPath)
    },
    showDeleteConfirm (index) {
      this.delIndex = index
      const self = this
      this.$confirm({
        centered: true,
        content: '确定删除该素材',
        onOk () {
          self.delElement()
        },
        cancelText: '取消',
        okText: '确定',
        onCancel () { }
      })
    },
    // 删除元素
    delElement () {
      this.workList.splice(this.delIndex, 1)
    },
    // 上传人设图完成
    async cardOnSuccess (response, filename, file, data) {
      this.human_card.package_image = response.key
      let img = new Image()
      getBase64(file, (oimg) => {
        img.src = oimg
        img.onload = () => {
          data.width = img.width
          data.height = img.height
          img = null
        }
      })
      // 上传水印图片 最终水印地址 http://wm.mindcomic.com/resources/cloud/title_image_web/fjsa1594015760ensz.png=zpace_wm_muti
      // data.originFileObj = file
      // // 添加水印
      // await this.addWaterMark(data, this.materialPath)
      this.workList = [this.human_card]
    },
    // 投稿提交
    submit () {
      this.form.validateFields((errors, values) => {
        if (errors) return

        if (this.workList.length <= 0) {
          this.$message.error('请上传投稿作品')
          return false
        }

        if (this.contributeInfo.category != '3') {
          let i = 0
          let imgNum = 0
          this.workList.forEach((item, index) => {
            // 检查昵称有没有填完
            if (item.title === '' && item.error === '') {
              this.workList[index].error = '昵称填完整才可以提交哦~'
              this.workList[index].errorType = '4'
              i++
            }
            if (item.image === '') {
              imgNum++
            }
          })

          if (i > 0) {
            this.$message.error('每个素材都需要填充名称后才可以进行提交哦')
            return false
          }
          if (imgNum > 0) {
            this.$message.error('每个素材都需要填充图片后才可以进行提交哦')
            return false
          }

          // 找出有错误数量
          const errList = this.workList.filter((item) => {
            return item.error !== ''
          })

          if (errList.length > 0) {
            // 如果有错误，则返回
            return false
          }
        }

        const res_data = []
        this.workList.forEach((item) => {
          const { title, image, width, height, watermark_image } = item
          res_data.push({ title, image, width, height, watermark_image })
        })
        const dataSend = {
          id: this.id,
          package_title: this.formData.package_title,
          res_data: JSON.stringify(res_data),
          contact: this.formData.contact || undefined
        }
        this.canSubmit = false
        this.$api.planning
          .postPlanning(dataSend)
          .then((res) => {
            if (res.status === 'ok') {
              this.$message.success(res.message.message)
              this.canSubmit = true
              this.$router.go(-1)
            }
          })
          .finally(() => {
            this.canSubmit = true
          })
      })
    },
    // 获取企划详情
    getInfo () {
      this.$api.planning.getPlanningDetail({ id: this.id }).then((res) => {
        if (res.status === 'ok') {
          this.contributeInfo = res.data
        }
      })
    },
    goback () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .card-upload img {
  max-height: inherit;
}
#contribute {
  background-color: #ffffff;
  min-height: 580px;
  .card-preview-list {
    display: flex;

    .card-preview-item {
      margin-right: 40px;
      .title {
        font-size: 14px;
        color: #999999;
      }

      .card-preview-img {
        border: 1px solid #e5e5e5;
        height: 391px;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        img {
          position: absolute;
          top: 0;
          left: 0;
          height: auto;
          display: block;
        }
        .card-display {
          width: 259px;
          height: 151px;
          border-radius: 8px;
          overflow: hidden;
          margin: 50px auto 0;
          position: relative;
          img {
            width: 259px !important;
            position: absolute;
            top: -156px;
            left: 0px;
          }
        }
        &.card_1 {
          width: 220px;
          img {
            width: 220px;
          }
        }
        &.card_2 {
          width: 277px;
          img {
            width: 277px;
          }
        }
      }
    }
  }
  .psd-icon {
    width: 18px;
    height: 20px;
    display: inline-block;
    margin-right: 8px;
  }
  .download-psd {
    font-size: 12px;
    &:hover {
      text-decoration: underline;
    }
  }
  .content {
    padding: 36px 0;

    .contribute-form {
      /deep/ .ant-form-item-label {
        width: 144px;
      }
      /deep/ .ant-form-item-label {
        width: 144px;
      }
      /deep/ .ant-form-item-control-wrapper {
        width: calc(~'100% - 144px');
      }
      /deep/ .cover-item {
        .ant-form-explain {
          margin-top: 8px;
        }
        .ant-form-item-children {
          display: flex;
          .cover-box {
            width: 120px;
            height: 120px;
            position: relative;
            overflow: hidden;
            &:hover {
              .mask {
                display: flex;
                .upload-btn {
                  display: block;
                }
              }
            }
            .mask {
              display: none;
              border-radius: 4px;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);

              justify-content: center;
              align-items: center;
              pointer-events: none;
              .upload-btn {
                display: none;
                pointer-events: none;
              }
            }
          }
          .tips {
            font-size: 12px;
            margin-left: 20px;
            p {
              margin: 0;
              line-height: 1;
              margin-bottom: 12px;
              color: #999999;
            }
          }
        }
      }
      .file-list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
        margin-bottom: 10px;
        .file-item {
          width: 200px;
          padding: 16px;
          border: 1px solid #f2f2f2;
          border-radius: 8px;
          position: relative;
          margin-top: 40px;
          margin-right: 42px;
          &.error {
            border: 1px solid #f5222d;
          }
          .image-view {
            width: 168px;
            height: 168px;
            margin-bottom: 12px;
            &__upload {
              border-radius: 8px;
            }
            /deep/ .upload-img {
              border-radius: 4px;
            }
          }
          .name {
            height: 32px;
            font-size: 14px;
            color: #666666;
            input {
              border-color: #e5e5e5;
              &:focus {
                border-color: @primary-color;
              }
            }
          }
          .close {
            font-size: 24px;
            position: absolute;
            top: -12px;
            right: -12px;
            color: #d6d6d6;
            line-height: 1;
            &::before {
              background-color: #ffffff;
            }
            &:hover {
              color: @primary-color;
              cursor: pointer;
            }
          }
          .error-tips {
            position: absolute;
            bottom: -38px;
            left: 0;
            color: #f5222d;
            font-size: 12px;
            white-space: nowrap;
          }
        }
      }
      .concat {
        .line {
          margin: 0 0 32px;
        }
      }
    }
  }
}
</style>
